import { createContext, ReactNode, useContext, useMemo } from 'react';
import { PersonTypes } from '@frontend/api-person';

export type PersonInfoStore = {
  personInfo?: PersonTypes.Person;
  locationId?: string;
};

export const PersonInfoContext = createContext<PersonInfoStore>({} as PersonInfoStore);

type PersonInfoStoreProviderProps = {
  children?: ReactNode;
  locationId: string;
  personInfo?: PersonTypes.Person;
};

export const PersonInfoStoreProvider = ({ children, locationId, personInfo }: PersonInfoStoreProviderProps) => {
  const providerValue = useMemo(
    () => ({
      personInfo,
      locationId,
    }),
    [personInfo, locationId]
  );

  return <PersonInfoContext.Provider value={providerValue}>{children}</PersonInfoContext.Provider>;
};

export const usePersonInfoStore = () => {
  const personInfoContext = useContext(PersonInfoContext);
  if (personInfoContext === undefined) {
    throw new Error('usePersonInfoStore must be used within a <PersonInfoStoreProvider>');
  }
  return personInfoContext;
};
